// https://formatjs.io/docs/polyfills
// Each polyfill and its locale data must finish before its dependents load.
export async function loadIntlPolyfills(): Promise<void> {
  if (!Intl.getCanonicalLocales) {
    await import('@formatjs/intl-getcanonicallocales/polyfill');
  }

  if (!Intl.Locale) {
    await import('@formatjs/intl-locale/polyfill');
  }

  if (!Intl.DisplayNames) {
    await import('@formatjs/intl-displaynames/polyfill');
    await import('@formatjs/intl-displaynames/locale-data/en.js');
    await import('@formatjs/intl-displaynames/locale-data/es.js');
    await import('@formatjs/intl-displaynames/locale-data/fr.js');
    await import('@formatjs/intl-displaynames/locale-data/de.js');
  }

  if (!Intl.ListFormat) {
    await import('@formatjs/intl-listformat/polyfill');
    await import('@formatjs/intl-listformat/locale-data/en.js');
    await import('@formatjs/intl-listformat/locale-data/es.js');
    await import('@formatjs/intl-listformat/locale-data/fr.js');
    await import('@formatjs/intl-listformat/locale-data/de.js');
  }

  if (!Intl.PluralRules) {
    await import('@formatjs/intl-pluralrules/polyfill');
    await import('@formatjs/intl-pluralrules/locale-data/en.js');
    await import('@formatjs/intl-pluralrules/locale-data/es.js');
    await import('@formatjs/intl-pluralrules/locale-data/fr.js');
    await import('@formatjs/intl-pluralrules/locale-data/de.js');
  }

  if (!Intl.NumberFormat) {
    await import('@formatjs/intl-numberformat/polyfill');
    await import('@formatjs/intl-numberformat/locale-data/en.js');
    await import('@formatjs/intl-numberformat/locale-data/es.js');
    await import('@formatjs/intl-numberformat/locale-data/fr.js');
    await import('@formatjs/intl-numberformat/locale-data/de.js');
  }

  if (!Intl.RelativeTimeFormat) {
    await import('@formatjs/intl-relativetimeformat/polyfill');
    await import('@formatjs/intl-relativetimeformat/locale-data/en.js');
    await import('@formatjs/intl-relativetimeformat/locale-data/es.js');
    await import('@formatjs/intl-relativetimeformat/locale-data/fr.js');
    await import('@formatjs/intl-relativetimeformat/locale-data/de.js');
  }
}
